import { useLoaderData } from "react-router-dom";
import * as React from "react";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Overview from "./account/Overview";
import Nodes from "./account/Nodes"
import Rewards from "./account/Rewards"
import Transactions from "./account/Transactions"
import { Alert } from "react-bootstrap";

export async function loader(params) {
  if (!params) return {};

  const accountInfo = await fetch(
    `https://smeshi-api.com/account/${params.accountid}`
  ).then((response) => {
    if (!response.ok) {
      return false
    }

    return response.json();
  });

  return { accountInfo };
}

function Account() {
  const [currentPage, setCurrentPage] = React.useState(1);
  const [transactions, setTransactions] = React.useState([]);
  const [rewards, setRewards] = React.useState([])
  const [currentRewardPage, setCurrentRewardPage] = React.useState(1)
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  const { accountInfo } = useLoaderData();

  // React.useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const apiUrl = `https://smeshi-api.com/account/${accountInfo.address}/transactions?sort=desc&limit=20&offset=${
  //         (currentPage - 1) * 20
  //       }`;
  //       const response = await fetch(apiUrl);
  //       const result = await response.json();

  //       setTransactions(() => setTransactions(
  //           result
  //       ));
  //     } catch (error) {
  //       setError(error.message);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, [currentPage, accountInfo]);

  // React.useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const apiUrl = `https://smeshi-api.com/account/${accountInfo.address}/rewards?sort=desc&limit=20&offset=${
  //         (currentRewardPage - 1) * 20
  //       }`;
  //       const response = await fetch(apiUrl);
  //       const result = await response.json();

  //       setRewards(() => setRewards(
  //           result
  //       ));
  //     } catch (error) {
  //       setError(error.message);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, [currentRewardPage, accountInfo]);

  const handlePreviousPage = () => {
    setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  const handleRewardPreviousPage = () => {
    setCurrentRewardPage(currentRewardPage - 1);
  }

  const handleRewardNextPage = () => {
    setCurrentRewardPage(currentRewardPage + 1);
  }

  const displayAccountInfo = () => {
    if (accountInfo) {
      return (
        <div className="stats-card">
                      <div className="stat">
            <div className="key">Address:</div>
            <div className="value">
              {accountInfo.address}
            </div>
          </div>
          <div className="stat">
            <div className="key">Balance:</div>
            <div className="value">
              {(accountInfo.balance / 1000000000).toFixed(2)} SMH
            </div>
          </div>
          <div className="stat">
            <div className="key">Value:</div>
            <div className="value">
              ${(accountInfo.usdValue / 1000000000).toFixed(2)}
            </div>
          </div>
          <div className="stat">
            <div className="key">Total Transactions:</div>
            <div className="value">{accountInfo.numberOfTransactions}</div>
          </div>
          <div className="stat">
            <div className="key">Reward Count:</div>
            <div className="value">{accountInfo.numberOfRewards}</div>
          </div>
          <div className="stat">
            <div className="key">Rewards Received:</div>
            <div className="value">
              {(accountInfo.totalRewards / 1000000000).toFixed(2)}
            </div>
          </div>
        </div>
      );
    } else {
      return <h1>Loading</h1>;
    }
  };

  const displayTransactionInfo = () => {
    const totalPages = Math.ceil(accountInfo.numberOfTransactions / 20);
    if (transactions) {
      return (
        <div id='transactions'>
          <table style={{ borderCollapse: "collapse", width: "100%" }}>
            <thead>
              <tr style={{ borderBottom: "1px solid #ddd", padding: "8px" }}>
                <th>Transaction Date</th>
                <th>Layer</th>
                <th>Status</th>
                <th>Amount</th>
                <th>Fee</th>
                <th>Type</th>
                <th>Sender</th>
                <th>Receiver</th>
              </tr>
            </thead>
            <tbody>
              {transactions.map((row, index) => (
                <tr
                  key={index}
                  style={{ borderBottom: "1px solid #ddd", padding: "8px" }}
                >
                  <td>{new Date(row.timestamp * 1000).toLocaleString()}</td>
                  <td>{row.layer}</td>
                  <td>{row.status === 0 ? "Completed" : "Error"}</td>
                  <td>{(row.amount / 1000000000).toFixed(2)} SMH</td>
                  <td>{row.fee}</td>
                  <td>{row.method}</td>
                  <td>{`${row.principalAccount.slice(
                    0,
                    4
                  )}...${row.principalAccount.slice(-4)}`}</td>
                  <td>{`${row.receiverAccount.slice(
                    0,
                    4
                  )}...${row.receiverAccount.slice(-4)}`}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div>
            <span>
              Page <strong>{currentPage}</strong> of{" "}
              <strong>{totalPages}</strong>
            </span>
            <button onClick={handlePreviousPage} disabled={currentPage === 1}>
              Previous
            </button>
            <button
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      );
    } else {
        return <h1>No Transactions</h1>
    }
  };

  const displayRewardInfo = () => {
    console.log('Loading Display Rewards')
    const totalPages = Math.ceil(accountInfo.numberOfRewards / 20);
    if (rewards) {
      return (
        <div id='Rewards'>
            
          <table style={{ borderCollapse: "collapse", width: "100%" }}>
            <thead>
              <tr style={{ borderBottom: "1px solid #ddd", padding: "8px" }}>
                <th>Reward Date</th>
                <th>Layer</th>
                <th>Amount</th>
                <th>Smesher ID</th>
              </tr>
            </thead>
            <tbody>
              {rewards.map((row, index) => (
                <tr
                  key={index}
                  style={{ borderBottom: "1px solid #ddd", padding: "8px" }}
                >
                  <td>{new Date(row.timestamp * 1000).toLocaleString()}</td>
                  <td>{row.layer}</td>
                  <td>{(row.rewards / 1000000000).toFixed(2)} SMH</td>
                  <td>{`${row.smesherId.slice(
                    0,
                    4
                  )}...${row.smesherId.slice(-4)}`}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div>
            <span>
              Page <strong>{currentRewardPage}</strong> of{" "}
              <strong>{totalPages}</strong>
            </span>
            <button onClick={handleRewardPreviousPage} disabled={currentRewardPage === 1}>
              Previous
            </button>
            <button
              onClick={handleRewardNextPage}
              disabled={currentRewardPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      );
    } else {
        return <h1>No Rewards</h1>
    }
  };

  return (
    <>
    <Tabs
      defaultActiveKey="overview"
      id="uncontrolled-tab-example"
      className="mb-3"
    >
      <Tab eventKey="overview" title="Overview">
        <Overview accountInfo={accountInfo} />
      </Tab>
      <Tab eventKey="nodes" title="Nodes">
        <Nodes accountInfo={accountInfo} />
      </Tab>
      <Tab eventKey="rewards" title="Rewards">
        <Rewards accountInfo={accountInfo} />
      </Tab>
      <Tab eventKey="transactions" title="Transactions">
        <Transactions accountInfo={accountInfo} />
      </Tab>
    </Tabs>
    </>
  );
}

export default Account;
